// src/constants/agency.ts

/**
 * ヒーロー動画のオプション（6種類）
 */
export const HERO_VIDEO_OPTIONS = [
  { value: 'mv_sp', label: '動画1（デフォルト）' },
  { value: 'mv_video1', label: '動画2' },
  { value: 'mv_video2', label: '動画3' },
  { value: 'mv_video3', label: '動画4' },
  { value: 'mv_video4', label: '動画5' },
  { value: 'mv_video5', label: '動画6' },
] as const;

/**
 * ビジョン画像のオプション（5種類）
 */
export const VISION_IMAGE_OPTIONS = [
  { value: 'vision_image1', label: '画像1（デフォルト）' },
  { value: 'vision_image2', label: '画像2' },
  { value: 'vision_image3', label: '画像3' },
  { value: 'vision_image4', label: '画像4' },
  { value: 'vision_image5', label: '画像5' },
] as const;

/**
 * 登録方法のラベルマップ
 */
export const REGISTRATION_METHOD_LABELS = {
  self: 'セルフ登録',
  manual: '手動登録',
} as const;

/**
 * 登録方法のバッジカラー
 */
export const REGISTRATION_METHOD_COLORS = {
  self: 'bg-blue-100 text-blue-800',
  manual: 'bg-gray-100 text-gray-800',
} as const;
